export default "__VITE_ASSET__5603125d__"